export default {
  imagesContainer: {
    width: ['calc(100% + 32px)', 'calc(100% + 32px)', 'calc(100% + 48px)', 'calc(100% + 48px)', '100%'],
    m: ['12px -16px 0 -16px', '12px -16px 0 -16px', '12px -24px 0 -24px', '12px -24px 0 -24px', '10px 0 0 0']
  },
  imageRow: (columns: Array<'horizontal' | 'vertical'>) => {
    let gridTemplateColumns: string | string[] = '1fr';
    let height: string | string[] = ['100%', '100%', '43.98047vw', '41.510417vw'];
    switch (columns.length) {
      case 1:
        gridTemplateColumns = columns[0] === 'vertical' ? ['1fr', '1fr', '1fr 1fr 1fr', '1fr 1fr 1fr', '1fr 1fr 1fr'] : ['1fr', '1fr', '2fr 1fr', '2fr 1fr', '2fr 1fr'];
        break;
      case 2:
        if (columns[0] === 'vertical') {
          gridTemplateColumns = columns[1] === 'horizontal' ? ['1fr', '1fr', 'calc(33% - 1px) 2fr', 'calc(33% - 1px) 2fr', 'calc(33% - 12px) 2fr'] : ['1fr', '1fr', '1fr 1fr 1fr', '1fr 1fr 1fr', '1fr 1fr 1fr'];
        } else {
          gridTemplateColumns = columns[1] === 'vertical' ? ['1fr', '1fr', '2fr calc(33% - 1px)', '2fr calc(33% - 1px)', '2fr calc(33% - 12px)'] : ['1fr', '1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr'];
          height = ['100%', '100%', '37.304688vw', '37.083333vw'];
        }
        break;
      case 3:
        if (columns.every(column => column === 'vertical')) {
          gridTemplateColumns = ['1fr', '1fr', '1fr 1fr 1fr', '1fr 1fr 1fr', '1fr 1fr 1fr'];
        }
        break;
      default:
        gridTemplateColumns = ['1fr', '1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr'];
        break;
    }
    return {
      display: 'grid',
      gridTemplateColumns,
      height,
      gridGap: ['2px', '2px', '4px', '4px', '24px'],
      mb: ['2px', '2px', '4px', '4px', '24px'],
      '&:last-of-type': {
        mb: 0
      }
    };
  },
  mobileImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: ['2px', '2px', '4px', '4px', '24px']
  },
  mobileImageItem: {
    width: '100%',
    '&:last-of-type': {
      mb: 0
    }
  },
  mobileVerticalImagesRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: ['2px', '2px', '4px', '4px', '24px'],
    width: '100%',
    '&:last-of-type': {
      mb: 0
    }
  },
  image: {
    width: '100%',
    height: ['auto', 'auto', 'unset']
  }
};